<template>
    <div class="flex-1">
        <v-card class="report-container p-0" style="border-radius: 12px">
            <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToReportsPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title v-if="this.lang == 'en'" class="size-16 dark-text">{{ this.report.titleEn
                }}</v-toolbar-title>
                <v-toolbar-title v-else class="size-16 dark-text">{{ this.report.titleAr }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div :style="{ display: reportFiltersCollapsed ? 'none' : 'block' }">
                    <div class="row align-items-start m-0 " style="flex: unset">
                        <div :class="{ 'col-md-4 ': item.type != 'checkbox', 'col-md-2': item.type == 'checkbox' }"
                            v-for="(item, index) in this.fields" :value="item.id" :key="item.id">

                            <v-label v-if="item.type != 'checkbox'" class="label_required">
                                <span v-if="lang == 'en'">{{ item.titleEn }}</span>
                                <span v-else>{{ item.titleAr }}</span>
                                <span v-if="item.required"> *</span>
                            </v-label>

                            <template v-if="item.type == 'text-field'">
                                <v-text-field :id="item.name" v-model="item.value" label="" solo></v-text-field>
                            </template>

                            <template id="reports-date-picker11" v-if="item.type == 'date-picker-field'">
                                <v-menu id="reports-date-picker" v-model="item.document_date_menu" content-class="p-0"
                                    :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :value="utils.dateFormat(item.value)" label="" readonly v-bind="attrs"
                                            v-on="on" solo append-icon="mdi-calendar" :id="item.name"
                                            @click:append="item.document_date_menu = true">
                                            <template v-slot:append>
                                                <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="item.value"
                                        @input="item.document_date_menu = false"></v-date-picker>
                                </v-menu>
                            </template>

                            <template v-if="item.type == 'multi-select-static'">
                                <multi-select class="light-bg add-arrow" v-model="item.value" :label="item.itemText"
                                    :track-by="item.itemValue" open-direction="bottom" :options="fields_options[index]"
                                    :searchable="false" :internal-search="false" :clear-on-select="false" :placeholder="$t('res_Label_SelectOption')"
                                    :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                                    :hide-selected="false" :multiple="false" @input="multiSelectStaticChange(item.fieldEvent, item.value)">
                                    <template slot="option" slot-scope="props">
                                        <span v-html="props.option.name"></span>
                                    </template>
                                    <template slot="singleLabel" slot-scope="props">
                                        <span>{{ ParseLabelContainingHtmlTags(props.option.name) }}</span>
                                    </template>
                                </multi-select>
                            </template>

                            <template v-if="item.type == 'multi-select'">
                                <multi-select class="light-bg add-arrow" v-model="item.value" :label="item.itemText"
                                    :track-by="item.itemValue" open-direction="bottom" :id="item.name"
                                    :options="fields_options[index]" :searchable="true" :internal-search="false"
                                    :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                                    :show-no-results="false" :hide-selected="false" :multiple="false"
                                    :placeholder="$t('res_Label_SelectOption')" @search-change="asyncFindValue"
                                    @close="clearArrayOnClose(item.id)">
                                    <template slot="option" slot-scope="props">
                                        <div style="height: 50px; width: 100%; display: flex">
                                            <div class="" style="">
                                                <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name)
                                                }}</v-avatar>
                                            </div>
                                            <div class="ad__box" v-if="props.option.isUser">
                                                <p class="ad__text__bold">{{ props.option.name }}</p>
                                                <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                            </div>
                                            <div class="ad__box" v-else>
                                                <p class="ad__text__bold">{{ props.option.name }}</p>
                                                <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                            </div>
                                        </div>
                                    </template>
                                    <template slot="singleLabel" slot-scope="props" v-if="props.option.name">
                                        {{ props.option.name }}
                                    </template>
                                    <template slot="noOptions" slot-scope="props">
                                        {{ $t("res_Msgs_EmptySearch") }}
                                    </template>
                                </multi-select>
                            </template>

                            <template v-if="item.type == 'checkbox'">
                                <v-label></v-label>
                                <div class="d-flex align-items-center m-0 mt-1 " style="height: 46px;">
                                    <v-checkbox v-model="item.value" color="primary" class="report_checkbox m-0"
                                        hide-details></v-checkbox>
                                    <label class="label_required m-0">
                                        <span v-if="lang == 'en'">{{ item.titleEn }}</span>
                                        <span v-else>{{ item.titleAr }}</span>
                                        <span v-if="item.required"> *</span>
                                    </label>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-end gap-2">
                    <v-btn class="light-blue" dense @click="clearValues">{{ $t("res_ButtonText_Clear") }}</v-btn>
                    <v-btn class="primary" dense @click="submitViewReport">{{ $t("res_ButtonText_ViewReport") }}</v-btn>
                    <v-btn v-if="reportFiltersCollapsed" class="primary" @click="reportFiltersCollapsed = !reportFiltersCollapsed"><v-icon>mdi-chevron-down</v-icon></v-btn>
                    <v-btn  v-if="!reportFiltersCollapsed" dense @click="reportFiltersCollapsed = !reportFiltersCollapsed" class="expand-advance-search light-blue mr-2"><v-icon> mdi-chevron-up </v-icon></v-btn>
                </div>

                <hr>

                <div class="d-flex flex-1 flex-column overflow-auto" style="min-height: 400px;" v-for="(grid, index) in report.grids"
                    :key="'grid_' + index">
                    <Pagination class="mb-2" :totalCount="pagingData[index].totalCount"
                        :pageSize="pagingData[index].pageSize" :pageIndex="pagingData[index].pageIndex"
                        @pageIndexChanged="pageIndexChanged" :arrayIndex="index"></Pagination>

                    <v-toolbar-title v-if="lang == 'en' && grid.titleEn" class="size-16 dark-text">{{ grid.titleEn}}</v-toolbar-title>

                    <v-toolbar-title v-else-if="grid.titleAr" class="size-16 dark-text">{{ grid.titleAr }}</v-toolbar-title>

                    <v-data-table :mobile-breakpoint="0" class="position-relative white flex-1 d-flex overflow-auto"
                        disable-sort :headers="grid.columns" :items="results[index]" :loading="loading"
                        loading-text="loading..." :no-data-text="$t('res_Label_NoData')"
                        :footer-props="{ 'items-per-page-text': 'Items per page' }" caption="" hide-default-header
                        :class="{ 'result_available': results[index].length != 0, 'no-data': results[index].length == 0 }"
                        header-fixed fixed-header :hide-default-footer="true" :items-per-page="pagingData[index].pageSize"  @dblclick:row="openComponent">
                        <template v-slot:header="{ props }">
                            <thead>
                                <th class="report_header" v-for="(head, index) in props.headers" v-bind:key="index">
                                    <span v-if="lang == 'en'">{{ head.text }}</span>
                                    <span v-else>{{ head.textAr }}</span>
                                </th>
                            </thead>
                        </template>
                        <template v-slot:item.subject="{ item }">
                            <a class="td-text-limit" v-tooltip="item.subject">{{ item.subject }}</a>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-chip dark v-bind:class=getStatus(item.status)>
                                {{ item.status }}
                            </v-chip>
                        </template>
                        <template v-slot:item.priority="{ item }">
                            <v-chip dark v-bind:class=getColor(item.priority)>
                                {{ item.priority }}
                            </v-chip>
                        </template>
                        <template v-slot:item.dueDate="{ item }">
                            <span>{{ utils.dateFormat(item.dueDate) }}</span>
                        </template>
                        <template v-slot:no-data>
                            <div>
                                <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                                <p class="m-0">{{ $t("res_No_new_items_here") }}</p>
                            </div>
                        </template>
                    </v-data-table>
                </div>

                <div class="d-flex flex-1 flex-row flex-wrap mb-2">
                    <div v-for="(chart, index) in report.charts" :key="'chart_' + index" class="d-flex flex-column m-2">
                        <v-card v-if="chart.show" class="bg-white px-4 rounded-top-corners" :style="{ width: chart.width, height: chart.height }">
                            <v-card-title class="d-flex flex-column align-start dashboarCardTitle mb-2">
                                <span class="d-flex items-center">
                                    {{ lang == 'en' ? chart.titleEn : chart.titleAr }}
                                    <v-icon :class="['mdi ml-2', getChartIcon(chart.type)]"></v-icon>
                                </span>
                            </v-card-title>
                            <canvas :id="chart.id"></canvas>
                        </v-card>
                    </div>
                </div>

            </div>            
            <v-card-actions class="gap-2 sticky-actions" v-if="isActionsDisplay == true">
                <v-spacer></v-spacer>
                <v-btn class="light-blue" style="min-width: 100px !important" @click="backToReportsPage()">{{ $t("res_Cancel") }}</v-btn>
                <v-btn class="primary" @click="exportExcelReport">{{ $t("res_Export_To_Excel") }}</v-btn>
                <v-btn class="primary" @click="printReport">{{ $t("res_Print_Report") }}</v-btn>
            </v-card-actions>
        </v-card>
        
        <v-dialog v-model="componentDialog" class="full-height-100vh" width="100vw" height="100vh"
			content-class="overflow-hidden full-height-100vh" @keydown.esc="closeComponentDialog">
            <component :is="currentComponent" v-bind="currentProperties" @[closeEventName]="closeComponentDialog" ></component>
		</v-dialog>

        <v-dialog v-model="correspondenceDialog" content-class="create-document-dialog fullscreen-dialog corr_dialog" fullscreen @keydown.esc="closeCorrespondenceDialog">
            <CreateDocumentView :documentId="documentId" :transferId="transferId" :openedFromNodeId="nodeId" :viewMode="viewMode" :delegationId="delegationId" :closeDialogEvent="closeCorrespondenceDialog"/>
        </v-dialog>
    </div>
</template>

<script>
import router from '@/router/index.js'
import axios from 'axios';
import constants from '@/assets/js/constants'
import MultiSelect, { Multiselect } from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
import Pagination from '@/components/Pagination.vue'
import Chart from 'chart.js/auto';
import CreateDocumentView from "@/views/CreateDocumentView.vue"

export default {
    props: ['id'],
    name: 'Report',
    components: { MultiSelect, Pagination, CreateDocumentView },
    data: function () {
        return {
            closeEventName:"",
            currentComponent:"",
            currentProperties:{},
            componentDialog: false,
            components:{},
            report: {},
            fields: [],
            fields_options: [],
            loading: false,
            results: [],
            charts: [],
            lang: '',
            document_date_menu: false,
            pagingData: [],
            isActionsDisplay: false,
            utils: utils,
            pagingSettings: {
                pageSize: 20,
                pageIndex: 0,
                totalCount: 0
            },
            reportFiltersCollapsed: false,
            documentId: 0,
            transferId: 0,
            viewMode: 'readonly',
            nodeId: 0,
            delegationId: 0,
            correspondenceDialog: false
        };
    },
methods:
{
    getChartIcon(type)
    {
        switch (type) 
        {
            case 'pie':
                return 'mdi-chart-pie'
            case 'doughnut':
                return 'mdi-chart-donut'
            case 'bar':
                return 'mdi-chart-bar'
            case 'line':
                return 'mdi-chart-line'
            case 'stacked-bar':
                return 'mdi-chart-bar-stacked'
            default:
                return 'mdi-chart-pie'
        }
    },
    multiSelectStaticChange(fieldEvent, selectedItem) 
    {
        if (fieldEvent == null || fieldEvent == undefined)
            return
        
        var event = fieldEvent.find(x => x.event == "Change");
        if (event == null && event == undefined) return

        var field = this.report.fields.find(x => x.id == event.fieldIdToEffect)
        var index = this.report.fields.indexOf(field);
        this.fields_options[index].forEach(element => {
            this.fields_options[index].splice(element)
        });
        field.value = null;
        this.asyncGetDynamicValue(field.apiName, index, selectedItem.id, true)
    },
    openComponent(event, {item}) 
    {
        if (window.defaultApplicationId == 1)
        {
            this.documentId = item.documentId
            this.transferId = item.transferId
            if(this.documentId == undefined || this.transferId == undefined)
                return
            this.nodeId = item.nodeId
            this.viewMode = 'readonly'
            this.delegationId = 0
            this.correspondenceDialog = true
        }
        else
        {
            if (this.components != null && this.components != undefined )
            {
                if (this.components.name != null && this.components.name!=undefined)
                {
                    this.currentComponent=this.components.name;
                    const dynamicObject = {};
                    this.components.props.forEach(function(props, index) 
                    {
                        if (props.fixedValue != null && props.fixedValue != undefined && props.fixedValue != '')
                            dynamicObject[props.propName] = props.fixedValue;
                        else
                            dynamicObject[props.propName] = item[props.bindingField];
                    });

                    this.closeEventName = this.components.dialogCloseEvent
                    this.currentProperties = dynamicObject
                    this.componentDialog = true
                }
            }
        }
    },
    closeCorrespondenceDialog() 
    {
        this.delegationId = 0
        this.documentId = 0
        this.transferId = 0
        this.correspondenceDialog = false
    },
    closeComponentDialog() 
    {
        this.componentDialog = false;
    },
    ParseLabelContainingHtmlTags(label) 
    {
        var doc = new DOMParser().parseFromString(label, 'text/html'); // remove HTML tags
        var label = doc.body.textContent || "";
        label = label.trim();
        label = label.replace(/[^a-zA-Z0-9ا-يء-ي ]/g, ""); // remove characters other than letters (English + Arabic), numbers, and spaces
        return label;
    },
    submitViewReport() 
    {
        this.submitReport(true);
    },
    getColor(priority) 
    {
        if (priority == 'Normal') return 'info'
        else if (priority == 'Urgent') return 'danger'
        else if (priority == 'Medium') return 'warning'
        else return 'white'
    },
    getStatus(status) 
    {
        if (status == null || status == '' || status == undefined)
            return ''
        return status.toLowerCase().replace(" ", "_")
    },
    openMultiSelectCtrl(id) 
    {
        if (id === 1) this.$refs.multiselect100.activate()
    },
    clearArrayOnClose(id) 
    {
        //this.fields_options.forEach(element => { element.length = 0 });
        var field = this.report.fields.find(x => x.id == id)
        this.fields_options[this.report.fields.indexOf(field)].length = 0
    },
    setReportParams: function () {
        var reportId = this.$route.query.id
        if (reportId != null) {
            axios.get(constants.baseApiUrl + 'Report/GetReport?reportId=' + reportId + '&applicationId=' + window.defaultApplicationId)
                .then(res => {
                    this.report = res.data;
                    this.fields = this.report.fields;
                    this.components = this.report?.components;
                    this.report.grids.forEach((grids, index) => {
                        this.results.push([])
                        this.pagingData.push({
                            pageSize: this.pagingSettings.pageSize,
                            pageIndex: this.pagingSettings.pageIndex,
                            totalCount: this.pagingSettings.totalCount,
                            arrayIndex: index
                        })
                    });
                    for (var i = 0; i < this.fields.length; i++) {
                        var field = this.fields[i];

                        if (field.type == 'multi-select-static') {
                            if (field.staticItems == null || field.staticItems == undefined) {
                                this.fields_options.push([])
                                this.asyncGetDynamicValue(field.apiName, i, "")
                            } else {
                                this.fields_options.push(field.staticItems)
                            }
                        }
                        else {
                            this.fields_options.push([])
                        }

                        this.fields.document_date_menu = false
                    }
                })
                .catch(err => console.log(err))
                .finally(f => 
                {
                    for (var i = 0; i < this.fields_options.length; i++) 
                    {
                        for (var j = 0; j < this.fields_options[i].length; j++) 
                        {
                            this.fields_options[i][j].name = this.utils.GetTranslatedValue(this.fields_options[i][j].name, this.fields_options[i][j].nameAr);
                        }
                    }
                })
        }
    },
    asyncFindValue: function (searchQuery, id) {
        if (searchQuery == '') return

        var field = this.report.fields.find(x => x.name == id)
        var item = this.report.fields.find(x => x.name == id)
        this.fields_options[this.report.fields.indexOf(field)].length = 0

        axios.get(constants.baseApiUrl + item.apiName + searchQuery)
            .then(res => {
                res.data.forEach(element => {
                    this.fields_options[this.report.fields.indexOf(field)].push(element)
                });
            })
            .catch(err => console.log(err))
    },
    asyncGetDynamicValue: function (apiName, index, searchQuery) {
        if (apiName == '') return
        axios.get(constants.baseApiUrl + apiName + searchQuery)
            .then(res => {
                res.data.forEach(element => {
                    this.fields_options[index].push(element)
                });
            })
            .catch(err => console.log(err))
    },
    submitReport(isResetPaging) 
    {
        if (isResetPaging) 
        {
            this.pagingData.forEach((paging, index) => {
                this.pagingData[index].totalCount = 0;
                this.pagingData[index].pageIndex = 0;
            });
        }

        let isFormValid = true
        this.fields.forEach(field => {
            if (field.required)
                if (field.value == null || field.value == undefined || field.value == '')
                    isFormValid = false
        });

        if (isFormValid == false) {
            window.showAlert('res_Msgs_FillRequired', 'warning')
        }
        else {
            this.isActionsDisplay = false;
            this.loading = true;
            let requestObject = {}
            requestObject.reportId = this.report.id;
            requestObject.reportFieldValues = this.getFieldValues(false)
            var getGrids = this.report.grids;
            getGrids.forEach((grid, index) => {
                requestObject.dataSoruceName = grid.dataSourceName
                this.GetReportDataApi(requestObject, index)
            });

            var getCharts = this.report.charts.filter(x => x.show)
            getCharts.forEach(async (chart, index) => {
                requestObject.dataSoruceName = chart.dataSourceName
                await this.GetReportDataApi(requestObject, index, 1)
            });
        }
    },
    async GetReportDataApi(requestObject, index, forCharts = 0) 
    {
        try {
            window.showLoading()
            let params = ""
            if(!forCharts)
                params = "?pageIndex=" + this.pagingData[index].pageIndex + "&pageSize=" + this.pagingData[index].pageSize
            const res = await axios.post(constants.baseApiUrl + "Report/GetReportData" + params, requestObject)
            this.loading = false;
            this.results[index] = [];
            if (forCharts)
                this.loadDynamicChart(res.data, index);
            else
                this.pushDataToGrid(res.data, index);
        } catch (error) {
            console.warn(error)
        }
        finally {
            this.loading = false;
            window.hideLoading()
        }
    },
    loadDynamicChart(data, index) 
    {
        var chart = this.report.charts[index];

        switch (chart.type) 
        {
            case 'pie':
            case 'doughnut':
                this.loadPieOrDoughnutChart(data, index, chart);
                break;
            case 'bar':
                this.loadBarChart(data, index, chart);
                break;
            default:
                break;
        }
    },
    loadBarChart(data, index, chart) 
    {
        var ctx = document.getElementById(chart.id);
        const parsedData = JSON.parse(data[0].jsonResult);

        if (chart.instance) {
            chart.instance.destroy();
            chart.instance = null;
        }

        const isRightToLeft = this.lang == 'ar'

        chart.instance = new Chart(ctx, {
            type: chart.type,
            data: parsedData,
            options: {
                scales: { x: { reverse: isRightToLeft ? true : false }, y: { position: isRightToLeft ? 'right' : 'left' } },
                ...chart.options
            }
        });
    },
    DisplayActions() 
    {
        this.results.forEach((results, index) => {
            if (results.length > 0) {
                this.isActionsDisplay = true;
            }
        });
    },
    pushDataToGrid(data, index) 
    {
        this.results[index] = data;
        if (data.length > 0) {
            this.isActionsDisplay = true;
            this.pagingData[index].totalCount = data[0].totalCount;
        }
    },
    clearGrid(index) 
    {
        this.results[index] = [];
    },
    clearValues() 
    {
        this.fields.forEach(field => 
        {
            field.value = null
        });
    },
    getFieldValues: function (withName) 
    {
        var fieldValues = []

        this.fields.forEach(field => {
            let index = fieldValues.length
            fieldValues[index] = {}
            fieldValues[index].name = field.name
            if (field.type == 'multi-select-static' || field.type == 'multi-select') {
                if (field.value != undefined && field.value != null) {
                    if (withName == true)
                        fieldValues[index].value = field.value.id + '#' + field.value.name;
                    else
                        fieldValues[index].value = field.value.id
                }
                else
                    fieldValues[index].value = null
            }
            else if (field.type == 'checkbox') {
                if (field.value == undefined || field.value == null)
                    fieldValues[index].value = false
                else
                    fieldValues[index].value = field.value
            }
            else {
                fieldValues[index].value = field.value
            }
        });

        return fieldValues
    },
    exportExcelReport() {
        let isFormValid = true
        this.fields.forEach(field => {
            if (field.required)
                if (field.value == null || field.value == undefined || field.value == '')
                    isFormValid = false
        });

        if (isFormValid == false) {
            window.showAlert('res_Msgs_FillRequired', 'warning');
        }
        else {
            const dataSoruceNames = [];
            this.report.grids.forEach((grid, index) => {
                dataSoruceNames.push(grid.dataSourceName)
            });
            let requestObject = {}
            requestObject.reportId = this.report.id;
            requestObject.dataSoruceNames = dataSoruceNames;
            requestObject.reportFieldValues = this.getFieldValues(true)

            window.showLoading()
            axios({
                url: constants.baseApiUrl + "Report/ExportExcelData",
                method: 'POST',
                responseType: 'blob', // important
                data: requestObject
            }).then((res) => {
                var blob = new Blob([res.data], { type: "application/octetstream" });

                const link = window.URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.setAttribute("download", this.report.titleEn + ".xlsx");
                a.setAttribute("href", link);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            })
                .finally(() => window.hideLoading())
        }
    },
    printReport() {
        let isFormValid = true
        this.fields.forEach(field => {
            if (field.required)
                if (field.value == null || field.value == undefined || field.value == '')
                    isFormValid = false
        });

        if (isFormValid == false) {
            window.showAlert('res_Msgs_FillRequired', 'warning')
        }
        else {
            const dataSoruceNames = [];
            this.report.grids.forEach((grid, index) => {
                dataSoruceNames.push(grid.dataSourceName)
            });

            let requestObject = {}
            requestObject.reportId = this.report.id;
            requestObject.reportFieldValues = this.getFieldValues(true)
            requestObject.dataSoruceNames = dataSoruceNames;
            this.printReportApi(requestObject);
        }
    },
    printReportApi(requestObject) {
        window.showLoading()
        axios({
            url: constants.baseApiUrl + "Report/PrintReportData",
            method: 'POST',
            responseType: 'blob', // important
            data: requestObject
        }).then((res) => {
            var blob = new Blob([res.data], { type: "application/octetstream" });

            const link = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.setAttribute("download", this.report.titleEn + ".pdf");
            a.setAttribute("href", link);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        })
            .finally(() => window.hideLoading())
    },
    backToReportsPage() {
        router.push({ name: 'reports' })
    },
    CapitalizeFirstLetter(str) {
        return utils.CapitalizeFirstLetter(str)
    },
    GetMultiSelectSubHeaderDisplay(options) {
        return utils.GetMultiSelectSubHeaderDisplay(options)
    },
    pageIndexChanged(pagingData, arrayIndex) {
        this.pagingData[pagingData.arrayIndex].pageSize = pagingData.pageSize;
        this.pagingData[pagingData.arrayIndex].pageIndex = pagingData.pageIndex;
        this.submitReport(false);
    },
    multiselectChange(fieldEvent, selectedItem) {
        if (fieldEvent == null || fieldEvent == undefined) {
            return
        }

            var event = fieldEvent.find(x => x.event == "Change");
            if (event == null && event == undefined) return

            var field = this.report.fields.find(x => x.id == event.fieldIdToEffect)
            var index = this.report.fields.indexOf(field);
            this.fields_options[index].forEach(element => {
                this.fields_options[index].splice(element)
            });
            field.value = null;
            this.asyncGetDynamicValue(field.apiName, index, selectedItem.id)
        }
    },
    mounted() 
    {
        this.lang = 'en'
        if (localStorage.getItem('lang') != null)
            this.lang = localStorage.getItem('lang')

        this.setReportParams()
    }
}
</script>

<style scoped>
.report-container .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
}

.report_header {
    height: 50px;
    vertical-align: middle;
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.015em;
    color: #667593;
}

.report-container .theme--light.v-data-table.v-data-table--fixed-header thead th,
.report-container .v-data-table__wrapper table thead {
    background-color: #FFF;
    box-shadow: none;
}

.report-container {
    height: calc(100vh - 116px);
    display: flex;
    flex-direction: column;
    border-radius: 12px !important;
    overflow: auto;
    box-shadow: none !important;
}

.report-container .border-top {
    display: flex;
    flex-direction: column;
}

.report-container .v-toolbar {
    height: 80px !important;
    padding: 0;
}

.report-container .v-toolbar__content {
    height: 100% !important;
    padding: 24px !important;
}
</style>